const CardSkeleton = () => {
  return (
    <div className="bg-dark-card-3 aspect-3/2 w-70 max-w-lg animate-pulse overflow-hidden rounded-xl shadow-[rgba(0,_0,_0,_0.25)_0px_25px_50px_-12px]">
      <div className="bg-dark-card-3 flex h-2/3 flex-col justify-between px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="bg-dark-card-3 h-6 w-6 rounded"></div>
          <div className="bg-dark-card-3 h-6 w-6 rounded"></div>
        </div>
        <div className="bg-dark-card-3 h-6 w-3/4"></div>
      </div>
      <div className="bg-dark-card-3 h-1/3">
        <div className="flex items-center justify-between px-4 pt-2">
          <div className="text-lg leading-6">
            <div className="bg-dark-card-3 mb-1 h-5 w-1/2"></div>
            <div className="bg-dark-card-3 h-5 w-1/2"></div>
          </div>
          <div className="bg-dark-card-3 h-6 w-6 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
